
import { Badge } from '@/components/ui/badge';
import { useFeed } from '@/hooks/use-feed';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

const FilterTabs = () => {
      const t = useTranslations('newsfeed');
      const { tags, total, changeFilter, filter } = useFeed();

      const data = useMemo(() => {
            return [{
                  label: t('all'),
                  slug: 'all',
                  count: total
            }, ...tags];
      }, [tags, total]);

      return (
            <div className="flex flex-wrap gap-2">
                  <Select onValueChange={(value) => changeFilter({ ...filter, tag: value })} value={filter?.tag}>
                        <SelectTrigger className="w-[150px] lg:w-[210px]">
                              <SelectValue placeholder={t('filter_by_tag')} />
                        </SelectTrigger>
                        <SelectContent>
                              {data.map((tag) => (
                                    <SelectItem key={tag.slug} value={tag.slug} className="flex flex-row items-center justify-between w-full">
                                          <Label className="text-sm w-full truncate">{tag.label}</Label>
                                          <Badge className=" bg-green-100 text-green-800" variant="secondary">{tag.count}</Badge>
                                    </SelectItem>
                              ))}
                        </SelectContent>
                  </Select>
            </div>
      );
};

export default FilterTabs;
